import __request__ from 'routing/request';
interface MediaType {
    readonly wildcard_subtype: boolean;
    readonly subtype: string;
    readonly wildcard_type: boolean;
    readonly type: string;
    readonly parameters: {
        readonly [_key: string]: string;
    };
}
interface GenericS3CreateInputRequest {
    readonly polling_time_unit: 'NANOSECONDS' | 'MICROSECONDS' | 'MILLISECONDS' | 'SECONDS' | 'MINUTES' | 'HOURS' | 'DAYS';
    readonly compression_type: string;
    readonly enable_throttling: boolean;
    readonly sqs_queue_name: string;
    readonly sqs_message_batch_size: number;
    readonly assume_role_arn: string;
    readonly aws_s3_secret: unknown;
    readonly name: string;
    readonly aws_s3_region: string;
    readonly override_source: string;
    readonly content_types: string;
    readonly aws_s3_access_key: string;
    readonly polling_interval: number;
}
interface stringMap {
    readonly [_key: string]: string;
}
interface GenericS3RequestImpl {
    readonly assume_role_arn: string;
    readonly aws_s3_secret: unknown;
    readonly aws_s3_region: string;
    readonly aws_s3_access_key: string;
    readonly sqs_queue_name: string;
}
/**
 * Validate input credentials
 */
export function checkCredentials(JSONbody: GenericS3RequestImpl): Promise<MediaType> {
    return __request__('POST', '/plugins/org.graylog.enterprise.integrations.generics3.api.GenericS3Resource/generics3/checkCredentials', JSONbody, {}, {
        'Accept': ['application/json']
    });
}
/**
 * Get all available AWS regions
 */
export function getAWSRegions(): Promise<stringMap> {
    return __request__('GET', '/plugins/org.graylog.enterprise.integrations.generics3.api.GenericS3Resource/generics3/getawsregions', null, {}, {
        'Accept': ['application/json']
    });
}
/**
 * Create a new GenericS3 input
 */
export function create(JSONbody: GenericS3CreateInputRequest, setup_wizard: boolean = false): Promise<MediaType> {
    return __request__('POST', '/plugins/org.graylog.enterprise.integrations.generics3.api.GenericS3Resource/generics3/inputs', JSONbody, { 'setup_wizard': setup_wizard }, {
        'Accept': ['application/json']
    });
}
